import { originalCategoryIconKey } from '../category-nav.js';
import { BN_PHRASES, KEYED_PHRASES } from './phrases.js';

export const LANG_STORAGE_KEY = 'ninet6-lang';

const CATEGORY_BN = {
  hot: 'হট',
  sports: 'স্পোর্টস',
  casino: 'ক্যাসিনো',
  slots: 'স্লটস',
  crash: 'ক্র্যাশ',
  table: 'টেবিল',
  fishing: 'ফিশিং',
  arcade: 'আর্কেড',
  lottery: 'লটারি',
};

function readStoredLang() {
  try {
    if (typeof localStorage === 'undefined') return 'en';
    return localStorage.getItem(LANG_STORAGE_KEY) === 'bn' ? 'bn' : 'en';
  } catch {
    return 'en';
  }
}

let lang = readStoredLang();
const listeners = new Set();

function applyDocumentLang(value) {
  try {
    if (typeof document !== 'undefined') document.documentElement.lang = value === 'bn' ? 'bn' : 'en';
  } catch {
    /* ignore */
  }
}

applyDocumentLang(lang);

export function getPlayerLang() {
  return lang;
}

export function publishPlayerLang(next) {
  const value = next === 'bn' ? 'bn' : 'en';
  lang = value;
  try {
    if (typeof localStorage !== 'undefined') localStorage.setItem(LANG_STORAGE_KEY, value);
  } catch {
    /* ignore */
  }
  applyDocumentLang(value);
  listeners.forEach((fn) => {
    try {
      fn(value);
    } catch {
      /* ignore */
    }
  });
  return value;
}

export function subscribePlayerLang(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function lookupKeyedPhrase(activeLang, key) {
  const table = KEYED_PHRASES[activeLang === 'bn' ? 'bn' : 'en'];
  if (!table || !Object.prototype.hasOwnProperty.call(table, key)) return undefined;
  return table[key];
}

/** Translate a frontend-authored English sentence. Unknown text, including game and provider names, stays unchanged. */
export function phrase(text, activeLang = getPlayerLang()) {
  const value = text == null ? '' : String(text);
  if (!value || activeLang !== 'bn') return value;
  return Object.prototype.hasOwnProperty.call(BN_PHRASES, value) ? BN_PHRASES[value] : value;
}

export function categoryLabel(name, activeLang = getPlayerLang(), id = '') {
  const raw = name == null ? '' : String(name);
  if (activeLang !== 'bn') return raw;
  const direct = CATEGORY_BN[raw.trim().toLowerCase()];
  if (direct) return direct;
  const iconKey = originalCategoryIconKey(id, raw);
  return CATEGORY_BN[iconKey] || raw;
}

/**
 * Bind language state to the same React the page renderer passes in.
 * The player shell inlines its own React, so a hook imported from the
 * node_modules React copy has a null dispatcher and the first render throws.
 */
export function createPlayerI18n({ useState, useEffect }) {
  return function usePlayerI18n() {
    const [lang, setLang] = useState(getPlayerLang);
    useEffect(() => subscribePlayerLang(setLang), []);
    const say = (text) => phrase(text, lang);
    return { lang, phrase: say, setLang: publishPlayerLang };
  };
}
